export const mediaQuery = {
  SP: 599,
  TABLET: 959,
}
